package er.prateek.crossly.notifications

enum class NotificationPermissionStatus {
    GRANTED,
    DENIED,
    /** Never asked (or, on iOS, `.notDetermined`) -- the native prompt can still be shown. */
    NOT_DETERMINED,
    /** Desktop/web: there is no notification permission model to query. */
    UNSUPPORTED,
}

/**
 * The per-platform runtime notification permission, reduced to what this app needs. Mirrors
 * [er.prateek.crossly.ads.AdHost]'s `expect`/`actual` + provider-object shape.
 */
interface NotificationPermissionController {
    /**
     * `suspend` because iOS has no synchronous read of the current authorization state --
     * `UNUserNotificationCenter` only answers via a completion handler. Android's actual
     * returns immediately despite the `suspend`.
     */
    suspend fun currentStatus(): NotificationPermissionStatus

    /**
     * Shows the native OS prompt. Only meaningful from [NotificationPermissionStatus.NOT_DETERMINED]
     * -- both platforms silently no-op (and just return the current status) if it's already been
     * decided once, which is why a denial is recovered from via [openAppSettings] instead.
     */
    suspend fun requestPermission(): NotificationPermissionStatus

    /** Deep-links into this app's system notification settings page. */
    fun openAppSettings()
}

object UnsupportedNotificationPermissionController : NotificationPermissionController {
    override suspend fun currentStatus(): NotificationPermissionStatus = NotificationPermissionStatus.UNSUPPORTED
    override suspend fun requestPermission(): NotificationPermissionStatus = NotificationPermissionStatus.UNSUPPORTED
    override fun openAppSettings() = Unit
}

expect object NotificationPermissionProvider {
    val controller: NotificationPermissionController
}
